import { useSelector } from "react-redux";

const useActivities = () => {
    const activities = useSelector((state) => state.activities);
    return activities;
};

export default useActivities;